import {Injectable} from '@angular/core';
import {PaymentRequestConfigurationDataService} from "./paymentRequestConfigurationData.service";
import {AbstractDataServiceDtoAdapter} from "../../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter";
import {PaymentRequestConfigurationModel} from "../../../api/entity/paymentRequestConfiguration.model";
import {PaymentRequestConfigurationConverter} from "../../../api/entity/converter/paymentRequestConfiguration.converter";

@Injectable()
export class PaymentRequestConfigurationDataServiceAdapter extends AbstractDataServiceDtoAdapter<PaymentRequestConfigurationModel, PaymentRequestConfigurationConverter> {
    constructor(dataService: PaymentRequestConfigurationDataService, converter: PaymentRequestConfigurationConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): PaymentRequestConfigurationModel {
        return new PaymentRequestConfigurationModel();
    }


}
